/** Check for an existence of prop */
const hasProp = <T extends object, P extends PropertyKey>(
  obj: T,
  prop: P
): obj is Extract<T, Record<P, unknown>> => {
  return Object.hasOwn(obj, prop);
};

export default hasProp;
